import { FC, useEffect, useState } from "react";
import { PdfHandler } from "../../../middleware/handlers/pdf-handler";
import type { PdfSearchMatches } from "../../../core/pdf/pdf-scene";

interface PdfSearchMenuProps {
  searchPanelReveal: boolean;
  searchMatches: PdfSearchMatches;
  searchNotFound: boolean;
}

export const PdfSearchMenu: FC<PdfSearchMenuProps> = ({
  searchPanelReveal,
  searchMatches,
  searchNotFound,
}) => {
  const [query, setQuery] = useState("");

  // Highlights belong to the open panel. Closing it clears them, and opening
  // it again starts a fresh search.
  useEffect(() => {
    if (!searchPanelReveal) {
      setQuery("");
      PdfHandler.ClearSearch();
    }
  }, [searchPanelReveal]);

  const Find = (findPrevious: boolean) => {
    if (query.trim() === "") {
      PdfHandler.ClearSearch();
    } else {
      PdfHandler.Search(query, findPrevious);
    }
  };

  if (!searchPanelReveal) return null;

  return (
    <div className="viewerToolPanel">
      <div className="viewerToolPanelHeader">
        <span className="viewerToolPanelLabel">SEARCH</span>
        <span className="viewerToolPanelName">Find text in the PDF</span>
        <input
          className="pdfSearchInput"
          type="text"
          placeholder="Search"
          autoFocus
          value={query}
          onChange={(event) => {
            setQuery(event.target.value);
          }}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              Find(event.shiftKey);
            }
          }}
        />
      </div>
      <div className="viewerToolRowWrapper">
        <span className="viewerToolRowHint">
          {searchNotFound
            ? "No matches."
            : searchMatches.total > 0
              ? `${searchMatches.current} of ${searchMatches.total} matches`
              : "Press Enter to search. Shift+Enter goes to the previous match."}
        </span>
      </div>
      <div className="viewerToolPanelFooter">
        <span>
          Only text stored in the PDF can be found, not text drawn as lines or
          scanned.
        </span>
        <div className="pdfSearchSteps">
          <input
            type="button"
            value="Previous"
            onClick={() => {
              Find(true);
            }}
          />
          <input
            type="button"
            value="Next"
            onClick={() => {
              Find(false);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default PdfSearchMenu;
